import api from './api';

const stakeholderService = {
  // Get all stakeholders with optional filters
  getStakeholders: async (params = {}) => {
    const response = await api.get('/stakeholders', { params });
    return response.data;
  },

  // Get a single stakeholder by ID
  getStakeholder: async (id) => {
    const response = await api.get(`/stakeholders/${id}`);
    return response.data;
  },

  // Create a new stakeholder
  createStakeholder: async (stakeholderData) => {
    const response = await api.post('/stakeholders', stakeholderData);
    return response.data;
  },

  // Update an existing stakeholder
  updateStakeholder: async (id, stakeholderData) => {
    const response = await api.put(`/stakeholders/${id}`, stakeholderData);
    return response.data;
  },

  // Delete a stakeholder
  deleteStakeholder: async (id) => {
    const response = await api.delete(`/stakeholders/${id}`);
    return response.data;
  },

  // Get stakeholder statistics
  getStakeholderStats: async (params = {}) => {
    const response = await api.get('/stakeholders/stats', { params });
    return response.data;
  }
};

export default stakeholderService;

